module.exports = __webpack_public_path__ + "static/media/promocoes-selecionadas-mobile.ec79ff4f.jpg";